export default __webpack_public_path__ + "static/media/classtrack_f4.6e812c1b.png";